import React from 'react';

import { Box } from '@vk-hr-tek/ui/Box';
import { Typography } from '@vk-hr-tek/ui/Typography';
import { Icon } from '@vk-hr-tek/ui/Icon';
import { toDateDeclensionMonth } from '@vk-hr-tek/ui/format';

interface SearchOptionMetaProps {
  labels: { label: string; isShrink: boolean }[];
  date?: string;
}

export const SearchOptionMeta = ({ labels, date }: SearchOptionMetaProps) => (
  <Box display="flex" justifyContent="space-between">
    <Box display="flex" gap="4">
      {labels.map(({ label, isShrink }, index) => (
        <Box
          key={index}
          display="flex"
          alignItems="center"
          gap="4"
          flexShrink={isShrink ? '1' : '0'}
        >
          <Typography
            maxLinesCount={1}
            variant="caption"
            color="text.light.tertirary"
            wordBreak="break-all"
          >
            {label}
          </Typography>
          {index !== labels.length - 1 && (
            <Box minWidth="16px" minHeight="16px">
              <Icon
                name="circle_small_filled"
                color="text.dark.secondary"
                size="16"
              />
            </Box>
          )}
        </Box>
      ))}
    </Box>
    {date && (
      <Box minWidth="max-content">
        <Typography
          maxLinesCount={1}
          variant="caption"
          color="text.light.tertirary"
        >
          {toDateDeclensionMonth(date)}
        </Typography>
      </Box>
    )}
  </Box>
);
